export default __webpack_public_path__ + "static/media/money.e8b6aa25.jpg";